export default {
  routes: {
    home: "Hem",
    login: "Login",
    register: "Registrera",
    logout: "Logout",
    company: "Företag",
    user: "Användare",
    contact: "Kontakt",
    userEdit: "Konto",
    superadmin: "Admin",

    connectors: "Connectors",

    devices: "Sensorer",
    deviceFields: "Sensorfält",
    devicePool: "Sensor pool",
    live: "Live Data",
  },

  connector: {
    toolbarTitle: "Connector",
    field: {
      name: "Namn",
      path: "URL",
      port: "Port",
      type: "Typ",
      active: "Aktiv",
      template: "Inställning",
    },
  },

  landing: {
    or: "ELLER",
  },

  log: {
    type: {
      sms: "SMS",
      app: "Applikation",
      warning: "Varning",
      error: "Error",
      userevent: "Userevent",
      login: "Login",
    },

    logTable: {
      title: "Logg",
    },

    activeAlarms: {
      title: "Aktiva larm",
    },

    activeUsersTable: {
      title: "Inloggade användare",
    },

    fields: {
      type: "Typ",
      user: "Användare",
      message: "Meddelande",
      createdAt: "Skapad",

      status: "Status",
      lastAction: "Event",
      lastSeen: "Timestamp",

      alarm: {
        name: "Namn",
        value: "Värde",
        messageSent: "Skickat notifikation",
      },
    },
  },

  common: {
    timestamp: "Tidsstämpel",
    lang: "Språk",
    error: "Ett fel uppstod försök igen senare",
    edit: "Redigera",
    delete: "Ta bort",
    purge: "Radera",
    submit: "Skicka",
    create: "Skapa",
    update: "Uppdatera",
    get: "Hämta",
    latest: "Senaste",
    value: "Värde",
    values: "Värden",
    amount: "Antal",

    confirmDelete: "Är du säker?",

    search: "Sök",
    close: "Stäng",

    login: "Logga in",
    register: "Registrera dig",
    email: "Email",
    password: "Lösenord",
    confirmPassword: "Upprepa lösenord",
    newPassword: "Nytt lösenord",
    forgotPassword: "Glömt lösenord",

    createdAt: "Skapad",
    updatedAt: "Updaterad",

    save: "Spara",
    show: "Visa",
    updated: "Updaterad",
    created: "Skapad",
    deleted: "Raderad",
    back: "Tillbaka",
    send: "Skicka",

    add: "Lägg till",

    settings: "Inställningar",

    noTagOrAppChoosen: "Sensor och/eller Applikation saknas",
    noDataFound: "Ingen data funnen",
    darkTheme: "Mörkt tema",

    active: "Aktiv",
    notActive: "Inte Aktiv",

    sent: "Skickat",
    notSent: "Inte Skickat",

    loginOrRegister: "Logga in eller registrera dig",

    or: "Eller",

    dashboard: "Gå till Dashboard",

    copy: "Kopiera",
    disagree: "Nej",
    verify: "Är du säker att du vill fortsätta?",
    accept: "Ja",
    yes: "Ja",
    no: "Nej",

    days: {
      monday: "Måndag",
      tuesday: "Tisdag",
      wednesday: "Onsdag",
      thursday: "Torsdag",
      friday: "Fredag",
      saturday: "Lördag",
      sunday: "Söndag",
    },

    validation: {
      required: "Detta fältet måste vara ifyllt",
      max: "Fältet har överstigit en maxgräns",
    },
  },

  device: {
    name: "Sensorer",
    serialNumber: "Serienummer",
    imei: "Imei",
    productName: "Produkt Id",
    deviceId: "Sensor Id",
    simIccid: "SimIccId",
    hardwareRevision: "Hårdvaru version",
    firmwareMajor: "Mjukvaro version major",
    firmwareMinor: "Mjukvaro version minor",
    lastContact: "Senaste kontakt",
    secret: "Hemlighet",
    metas: "Meta",

    fields: {
      name: "Sensorfält",
      deviceFieldId: "Id",
      label: "Ny Nyckel",
      key: "Nyckel",
      modifier: "Formel",
      ignore: "Ignorera fält",
      device: "Sensor",
      template: "Template",
      templateDefault: "Custom",
      ignoreStatus: "Status",
      lastContact: "Senaste kontakt",

      dataTableTitle: "Fält för sensor",
      addSensorField: "Lägg till ett nytt sensorfält",

      modifierDescription:
        "Använd V för det värdet som enheten används av. Tillexempel 'V/100' delar värdet från sensorn med 100",

      actions: "",
    },

    data: {
      lastFive: "Senaste 5 värden",
    },

    pool: {
      toolbar: "Sensor pool",
      name: "Sensor pool",
    },

    meta: {
      title: "Frifält",
      keyName: "Namn",
      value: "Värde",
    },
  },

  live: {
    waiting: "Väntar på att sensorer ansluter...",
    statusOk: "CONNECTED",
    statusNo: "DISCONNECTED",
    title: "Live Data",
  },

  contact: {
    title: "Kontakta oss",
    descriptionTitle: "NB IOTECH",
    description:
      "Vi på NB IOTECH vet att det kan vara svårt att komma igång med dina sensorer. Tveka inte på att kontakta oss vid frågor eller rådgivning.",
    emailTitle: "Email",
    email: "info@nb-iot.se",
    phoneTitle: "Telefon",
    phoneOne: "+46 (0) 500 6000 22",
    phoneTwo: "+46 (0) 733 165 100",
    locationSiencepark: "Skövde Science Park",
    locationStreet: "Kaplansgatan 16B",
    locationPostalcode: "521 32 Skövde",
    locationCountry: "Sweden",
  },

  company: {
    name: "Företag",
    orgNumber: "Org-nummer",

    companyInfo: "Företags information",

    addUser: "Lägg till användare",

    invite: "Bjud in en användare",
    inviteSent: "Inbjudan skickad",
    inviteFailed:
      "Kunde inte hitta användaren. Se till att användaren är registrerad och inte tillhör ett företag redan!",

    fields: {
      name: "Företagsnamn",
      orgNumber: "Org-nummer",
      postalAdress: "Postadress",
      deliveryAdress: "Leveransadress",
      contactPhonenumber: "Kontakt telefonnummer",
      invoiceAdress: "Epost för faktura",
      refrenceNmuber: "Referensnummer",
      image: "Företags logotyp",
    },

    validation: {
      nameRequired: "Du måste fylla i Företagsnamn",
      nameMax: "Företagsnamn kan högst vara 255 karaktärer",

      orgNumberRequired: "Du måste fylla i Org-nummer",
      orgNumberFormatError: "Fel format på Org-nummer",

      emailRequired: "Du måste fylla i Email",
      emailFormatError: "Ange giltig Email address",

      passwordMissmatch: "Lösenorden matchar inte",
    },
  },

  user: {
    name: "Användare",
    email: "Email",
    role: "Roll",
    userInfo: "Personliga uppgifter",
    loginFailed: "Inloggning misslyckades",
    signInFailed: "Email/lösenord matchar inte försök igen",
    loginSuccessful: "Inloggad",
    updateFailed: "Uppdateringen misslyckades",
    edit: "Redigera",
    forgotPassword: "Glömt lösenord?",

    fields: {
      name: "Namn",
      phoneNumber: "Telefonnummer",
      email: "Email",
      password: "Lösenord",
    },
  },

  validation: {
    required: "{0} måste vara ifylld",
    max: "{0} får max vara {1} karaktärer",
    requiredSingle: "Detta fält måste vara ifyllt",
    toLong: "Detta fält överstiger maxlängd",
    contryCodeError:
      "Glöm inte att telefonnummret måste ha en landskod (ex 4607xxxxxxxx)",

    passwordMissmatch: "Lösenorden matchar inte",
  },

  warning: {
    amount: "Aktiva Larm:",
    notation: "{0} st",
  },
};
